import { FC, useCallback, useState } from 'react';

import classNames from 'classnames';

import { useAppSelector } from '../../../hooks/redux';
import Button from '../../common/button';
import { IJournalResult } from '../../../store/types';
import type { PsyToolsId } from '../../meet/tools-panel/types';

export interface IPsyBlock {
  result?: IJournalResult;
  setResult: React.Dispatch<React.SetStateAction<IJournalResult>>;
  onSetMenu?: (menuId: PsyToolsId | 0) => void;
  onToolActivated?: (toolId: string, properties?: Record<string, unknown>) => void;
}

export const NewQuestionsPsy: FC<IPsyBlock> = ({ setResult }) => {
  const psyTools = useAppSelector((state) => state.psyToolsSlice.tools);
  const [questions, setQuestions] = useState<string[]>([]);
  const [finishQue, setFinishQue] = useState(false);
  const getQuestions = useCallback(() => {
    try {
      const new_question_block = psyTools.find((el) => el.name === 'new_question');
      const psy_questions = new_question_block?.psy_tool_settings[0].value || [];
      if (questions?.length !== 30) {
        const filtred_que = psy_questions.filter((el) => !questions.includes(el));
        if (filtred_que.length === 1) {
          const random_question = filtred_que[Math.floor(Math.random() * filtred_que.length)];
          setQuestions((prev) => [random_question, ...prev]);
          setFinishQue(true);

          return;
        }
        const random_question = filtred_que[Math.floor(Math.random() * filtred_que.length)];
        setQuestions((prev) => [random_question, ...prev]);
        const data = { date_time: new Date().toISOString(), question: random_question };

        setResult &&
          setResult((prev) => {
            return {
              ...prev,
              questions: [...prev.questions, data],
            };
          });
      }
    } catch (error) {
      console.log(error);
    }
  }, [psyTools, questions, setResult]);

  return (
    <div className="sm:w-[30vw] lg:w-[15vw] md:min-w-[300px] h-full flex flex-col">
      <div className="flex mr-[3rem] ml-[1rem] mt-[1rem] font-comfortaa font-bold text-2xl text-white">
        Подкинь вопрос
      </div>
      <div className="ttext-base text-white p-[1rem]">Вопросы видит только психолог</div>
      <div className="flex flex-col gap-[13px] md:gap-[20px] lg:gap-[15px] overflow-y-auto pr-[10px] white-scroll mb-5 ">
        {questions.map((el, idx) => (
          <div
            className={classNames(
              'text-xs lg:text-base text-white bg-blackBlue rounded-[5px] lg:rounded-[20px] p-[10px] lg:p-[20px]',
              {
                '!text-[#000] !bg-white': idx === 0,
              },
            )}
            key={idx}
          >
            {el}
          </div>
        ))}
      </div>
      <div className="mt-auto flex flex-row">
        <Button
          onClick={() => getQuestions()}
          className="!text-base xl:!text-base !self-center"
          disabled={finishQue || questions.length === 30}
        >
          Покажи новый вопрос
        </Button>
        <div className="min-w-[48px] w-[48px]"></div>
      </div>
    </div>
  );
};
